"use strict";

var _defineProperty = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.populateHeader = function () {
  return function (context) {
    var app = context.app,
        accessToken = context.params.accessToken;
    var authentication = app.authentication; // Set REST header if necessary

    if (app.rest && accessToken) {
      var _authentication$optio = authentication.options,
          scheme = _authentication$optio.scheme,
          header = _authentication$optio.header;
      var authHeader = "".concat(scheme, " ").concat(accessToken);
      context.params.headers = Object.assign({}, _defineProperty({}, header, authHeader), context.params.headers);
    }

    return context;
  };
};